import { Dialog } from '@elementary/common-ui/components';
import { ReactComponent as DeleteIcon } from '@elementary/common-ui/assets/20x20/trash.svg';
import { Typography } from '@mui/material';
import { fontSize, fontWeight } from '@elementary/common-ui/style/utils';
import { Token } from './types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  token: Token;
  onDelete: (tokenId: string) => Promise<void>;
  isDeleting: boolean;
  tokenType: 'personal' | 'account';
};

const DeleteTokenDialog = ({
  isOpen,
  onClose,
  token,
  onDelete,
  isDeleting,
  tokenType,
}: Props) => {
  const handleDelete = async () => {
    await onDelete(token.id);
    onClose();
  };

  const tokenTypeLabel = tokenType === 'personal' ? 'personal' : 'account';

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      onConfirmButtonClick={handleDelete}
      isLoading={isDeleting}
      titleIcon={<DeleteIcon />}
      title={`Delete ${tokenTypeLabel} token`}
      confirmText="Delete"
      secondaryMessage="You won't be able to undo this process."
      message={
        <Typography sx={{ fontSize: fontSize('sm') }}>
          Are you sure you want to delete{' '}
          <Typography
            component={'span'}
            sx={{
              fontSize: fontSize('sm'),
              fontWeight: fontWeight('semibold'),
            }}
          >
            {`'${token.description}'`}
          </Typography>{' '}
          from your tokens?
        </Typography>
      }
    />
  );
};

export default DeleteTokenDialog;
